import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ICommonEvent } from '../interfaces/ICommon';

@Injectable({
  providedIn: 'root'
})
export class CommonService {
  commonSubject = new Subject<ICommonEvent>();
  commonObservable$ = this.commonSubject.asObservable();
}
